// src/components/pages/Title.jsx
import { useEffect, useState } from "react";
import { titleContent } from "../../data/TitleContent";
import "../styles/title.css";

export const Title = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth < 768);

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);

    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  const content = isMobile ? titleContent.mobile : titleContent.desktop;

  const handleCTAClick = () => {
    document.getElementById("projects")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header>
      <h1 className="title_name">Alessandro Branco</h1>
      <h2 className="title_description">{content.header}</h2>
      <h3 className="title_subheader">{content.subheader}</h3>
      <p className="title_paragraph">{content.paragraph}</p>

      <button
        onClick={handleCTAClick}
        className="title_cta"
        aria-label="Scroll to projects"
      >
        View My Work
        <span aria-hidden="true">↓</span>
      </button>
    </header>
  );
};